import React, { useEffect, useState } from "react";
import { ShieldCheck, Loader2, AlertTriangle } from "lucide-react";
import { api, formatApiError } from "../lib/api";

// Halaman jembatan OIDC (authorization_endpoint). Dipanggil browser dari VENTE PEOPLE.
// Memastikan user sudah login ERP, lalu minta authorization code ke backend & kembali ke People.
export default function OidcAuthorize() {
  const [error, setError] = useState("");

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const payload = {
      response_type: sp.get("response_type") || "",
      client_id: sp.get("client_id") || "",
      redirect_uri: sp.get("redirect_uri") || "",
      scope: sp.get("scope") || "",
      state: sp.get("state") || "",
      nonce: sp.get("nonce") || "",
      code_challenge: sp.get("code_challenge") || "",
      code_challenge_method: sp.get("code_challenge_method") || "S256",
    };
    const next = "/oidc/authorize" + window.location.search;
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.replace("/login?next=" + encodeURIComponent(next));
      return;
    }
    api.post("/oidc/authorize", payload)
      .then((r) => { window.location.replace(r.data.redirect); })
      .catch((e) => {
        if (e.response?.status === 401) {
          window.location.replace("/login?next=" + encodeURIComponent(next));
        } else {
          setError(formatApiError(e.response?.data?.detail) || "Permintaan login tidak valid.");
        }
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f3ede4] p-6" data-testid="oidc-authorize-page">
      <div className="w-full max-w-sm bg-[#fbf7f1] border border-[#e6dccb] rounded-3xl shadow-xl p-8 text-center">
        {error ? (
          <>
            <AlertTriangle className="w-10 h-10 mx-auto text-status-reject mb-3" />
            <div className="font-heading font-bold text-cocoa text-lg">Login gagal</div>
            <p className="text-sm text-wmuted mt-2" data-testid="oidc-authorize-error">{error}</p>
            <a href="/" className="inline-block mt-5 text-sm text-cocoa font-medium underline">Kembali ke ERP</a>
          </>
        ) : (
          <>
            <ShieldCheck className="w-10 h-10 mx-auto text-cocoa mb-3" />
            <div className="font-heading font-bold text-cocoa text-lg">Menghubungkan ke VENTE PEOPLE</div>
            <div className="flex items-center justify-center gap-2 text-wmuted text-sm mt-3">
              <Loader2 className="w-4 h-4 animate-spin" /> Memverifikasi akun ERP Anda...
            </div>
          </>
        )}
      </div>
    </div>
  );
}
